import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4">
          Pronto a scoprire
          <br />
          <span className="text-accent-500">Itaobuy Spreadsheet</span>?
        </h2>
        <p className="text-base text-foreground-500 mb-10 max-w-xl mx-auto leading-relaxed">
          Accedi ora allo spreadsheet completo e inizia a trovare i prodotti migliori in pochi secondi.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-10 py-4 rounded-full bg-primary-500 text-background-50 text-base font-semibold hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Accedi allo Spreadsheet Completo
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
          <Link
            to="/articolo/guida-completa-itaobuy-spreadsheet"
            className="w-full sm:w-auto px-10 py-4 rounded-full border-2 border-foreground-300 text-foreground-700 text-base font-semibold hover:border-foreground-500 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Leggi la Guida
            <i className="ri-book-open-line ml-2"></i>
          </Link>
        </div>

        <div className="relative overflow-hidden rounded-2xl" style={{ height: '140px' }}>
          <img
            src="https://readdy.ai/api/search-image?query=Horizontal%20product%20runway%20flat%20lay%20row%20with%20tan%20leather%20shoes%2C%20cream%20knit%20sweater%2C%20beige%20handbag%2C%20neutral%20fashion%20items%20evenly%20spaced%20on%20warm%20cream%20surface%2C%20minimalist%20product%20photography%2C%20soft%20studio%20lighting%2C%20clean%20Scandinavian%20aesthetic%2C%20seamless%20product%20lineup%2C%20warm%20harmonious%20tones&width=1600&height=280&seq=cta-v2-product-strip&orientation=landscape"
            alt="Itaobuy Spreadsheet collezione prodotti"
            title="Itaobuy Spreadsheet prodotti"
            className="w-full h-full object-cover"
          />
        </div>
      </div>
    </section>
  );
}